import { useCallback, useMemo } from "react";

import { SelectAllOption } from "ds/components/Table/types";
import { StackRoleBindingView } from "shared/Stack/Roles/types";

import useStackRolesTableSelectionStore from "./useStackRolesTableSelectionStore";

type UseStackRolesSelectionOptionsResult = {
  selectionOptions: SelectAllOption[];
  stackRolesMap: Map<string, StackRoleBindingView>;
};

const useStackRolesSelectionOptions = (
  roles: StackRoleBindingView[]
): UseStackRolesSelectionOptionsResult => {
  const { replaceSelected } = useStackRolesTableSelectionStore();

  const selectAllItems = useCallback(async () => {
    replaceSelected(roles.map((role) => role.id));
  }, [replaceSelected, roles]);

  const stackRolesMap = useMemo(() => new Map(roles.map((role) => [role.id, role])), [roles]);

  const selectionOptions = useMemo(
    () => [
      {
        title: "Select all roles",
        onSelect: selectAllItems,
      },
    ],
    [selectAllItems]
  );

  return {
    selectionOptions,
    stackRolesMap,
  };
};

export default useStackRolesSelectionOptions;
